module.exports = __webpack_public_path__ + "820c5720922c3280af089d81562b53ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-3.jpg
// module id = 1113
// module chunks = 1